<app-header></app-header>
<div class="container-xl bg-praxis-third shadow" style="padding:150px 0 0;">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
